import { useForm } from "react-hook-form";
import Input from "../../Components/CommonCommponents/Input";
import { useEffect } from "react";
import { Button } from "antd";
import Select from "../../Components/CommonCommponents/select/Select";
import AuthService from "../../Service.js/authService";
import { useState } from "react";
import DatePicker from "../../Components/CommonCommponents/DatePicker";
import CandodateService from "../../Service.js/CandidateService";
import toast from "react-hot-toast";
import dayjs from "dayjs";
import RadioGroup from "../../Components/CommonCommponents/RadioGroup";
import { dateConverter } from "../../Components/Utilities/util";
import { isEmpty, values } from "lodash";
import customParseFormat from "dayjs/plugin/customParseFormat";
import CTCField from "../../Components/Candidates/CTCField";
dayjs.extend(customParseFormat);

const BasicDetails = (props) => {
  const [educationSearch, setEducationSerach] = useState();
  const [educationData, setEducationData] = useState();
  const [selectedLocation, setSelectedLocation] = useState();
  const [languages, setLanguages] = useState();
  const [locations, setLocations] = useState();
  const [natinalityKnown, setNatinalityKnown] = useState();
  const [preferredWorkingCondition, setPreferredWorkingCondition] = useState();

  const {
    register,
    control,
    setValue,
    setError,
    handleSubmit,
    watch,
    reset,
    formState: { errors, dirtyFields },
  } = useForm();

  const ANSWER_OPTIONS = [
    { label: "Yes", value: "true" },
    { label: "No", value: "false" },
  ];
  const validateDOB = (_, dateString) => {
    if (!dateString) {
      return Promise.reject("Please choose a date.");
    }

    const selectedDate = new Date(dateString);
    const eighteenYearsAgo = new Date();
    eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);

    if (selectedDate > eighteenYearsAgo) {
      return Promise.reject("Applicants must be 18 years or older.");
    }

    return Promise.resolve();
  };

  const MartialTypes = [
    { value: "married", label: "Married" },
    { value: "Single", label: "Single" },
  ];
  const WorkTypes = [
    { value: "office", label: "Office" },
    { value: "workfromhome", label: "work from Home" },
    { value: "hybrid", label: "Hybrid" },
  ];
  const noticeTypes = [
    { value: "15", label: "15 Days or less" },
    { value: "1", label: "1 Month" },
    { value: "2", label: "2 Months" },
    { value: "3", label: "3 Months" },
    { value: "4", label: "More than 3 Months" },
    { value: "3", label: "Serving Notice Period" },
  ];
  const selectedType = watch("disability");
  const getPreferredWorkingCondition = async () => {
    await AuthService.getPreferredWorkingCondition()
      .then((response) => {
        setPreferredWorkingCondition(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const nationality = [1];
  const getData = (data) => {
    const slecetedLanguages = [];
    props?.details?.languages.map((data, index) =>
      slecetedLanguages.push({
        value: data.language__id,
        label: data.language__language
        .charAt(0)
        .toUpperCase() + data.language__language.slice(1),
      })
    );
    const nationality = props?.details?.nationality;
    const location = {
      value: props?.details?.location,
      label: props?.details?.location,
    };
    console.log("dob", location);
    if (
      nationality !== null &&
      nationality !== undefined &&
      Object.keys(nationality).length > 0
    ) {
      nationality.value = nationality?.id;
      nationality.label = nationality?.nationality;
    }
    setValue("locations", location.value !== null ? location : undefined);
    setValue("total_exp", props.details?.total_exp);
    setValue("notice_period", props.details?.notice_period);
    setValue("nationality", nationality);
    setValue(
      "preferred_working_condition",
      props.details?.preferred_working_condition
    );
    setValue("ctc_currency_code", props.details?.ctc_currency_code);
    setValue("current_ctc", props.details?.current_ctc);
    setValue("expected_ctc", props.details?.expected_ctc);
    setValue(
      "dob",
      props?.details?.dob ? dayjs(props?.details?.dob, "DD-MM-YYYY") : ""
    );
    setValue("languages", slecetedLanguages);
    setValue("disability", props.details?.disability.toString());
  };
  useEffect(() => {
    getData();
    getPreferredWorkingCondition();
  }, []);
  console.log("props", props);
  const handleSearch = async (serachValue) => {
    await AuthService.telePort(serachValue).then((response) => {
      var cities = response.data["_embedded"]["city:search-results"];
      // console.log("response",response.data.embedded)
      var data = getSearch(cities);
      console.log("data", data);
      setSelectedLocation(data);
    });
  };
  const getSearch = (cities) => {
    var location = [];
    cities &&
      cities.map((data, index) =>
        location.push({
          value: index,
          label: data.matching_full_name,
        })
      );

    return location;
  };
  const onChangeType = (e, onChange) => {
    // console.log(
    //   "esxc",
    //   e.map((i) => i.value)
    // );
    // onChange(e.map((i) => i.value));
    // update(index, e.value);
    // console.log('onChangeQuestionType', e.value);
  };
  const handleLangages = async (serachValue) => {
    await AuthService.getLanguages(serachValue)
      .then((response) => {
        setLanguages(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleLocations = async (serachValue) => {
    await AuthService.getLocations(serachValue)
      .then((response) => {
        setLocations(response.data.data.locations);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleNationality = async (serachValue) => {
    await AuthService.getNationality(serachValue)
      .then((response) => {
        setNatinalityKnown(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleEducationsearch = async (value) => {
    setEducationSerach(value);
    await AuthService.educationDetails(educationSearch)
      .then((response) => {
        setEducationData(response.data.data);
        //setSkills(response.data.data.skills)
        //setLocation(response.data.data.location)
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const candidateInfo = async () => {
    await CandodateService.candidateDetails()
      .then((response) => {})
      .catch((error) => {});
  };

  const onSubmit = async (data) => {
   
    if (data.total_exp < 0) {
      setError("total_exp", {
        type: "server",
        message: "experience should be a positive number",
      });
      return false;
    }

    const languages = data.languages.map((obj) => obj.value);
    const nationality = data.nationality.value;
    const selecteditems = data.location;
    const date = dateConverter(data.dob);
    const dob = date.convertedValue;

    const locations = data?.locations?.label;
   

    let candidate_city = null;
    let candidate_state = null;
    let candidate_country = null;
    if (locations) {
      const string = locations.split(",");
     
      candidate_city = string[0];
      candidate_state = string[1];
      candidate_country = string[2];
    }

    console.log("location", locations);
    let payload = {};





   // Check dirty fields and update the payload if needed
  if (dirtyFields.dob) payload.dob = dob;
  if (dirtyFields.candidate_city || candidate_city) payload.candidate_city = candidate_city;
  if (dirtyFields.candidate_state || candidate_state) payload.candidate_state = candidate_state;
  if (dirtyFields.candidate_country || candidate_country) payload.candidate_country = candidate_country;

  // Check if 'locations' is dirty and add the location fields to the payload
  if (dirtyFields.locations && locations) {
    payload.candidate_city = candidate_city;
    payload.candidate_state = candidate_state;
    payload.candidate_country = candidate_country;
  }

  // Other fields in the form
  if (dirtyFields.total_exp) payload.total_exp = data.total_exp;
  if (dirtyFields.notice_period) payload.notice_period = data.notice_period;
  if (dirtyFields.preferred_working_condition) payload.preferred_working_condition = data.preferred_working_condition;
  if (dirtyFields.current_ctc) payload.current_ctc = data.current_ctc;
  if (dirtyFields.expected_ctc) payload.expected_ctc = data.expected_ctc;
  
  if (dirtyFields.ctc_currency_code) payload.ctc_currency_code = data.ctc_currency_code?.value



  if (dirtyFields.languages) payload.languages = languages;
  if (dirtyFields.nationality) payload.nationality = nationality;
  if (dirtyFields.disability) payload.disability = data.disability;

  // Log the final payload for debugging
  console.log("Final Payload:", payload);


  await CandodateService.updatecandidaetDetails(payload, props?.details?.id)
  .then(
    (oResponse) => {
      toast.success("Successfully Updated!");
      props.close();
      candidateInfo();
    },
    (error) => {
      const errorsObj = error?.response?.data?.error_info;

      // Handle server-side errors
      Object.keys(errorsObj).forEach((field) => {
        const messages = errorsObj[field];
        setError(field, {
          type: "server",
          message: messages.join(". "),
        });
      });
    }
  )

   
      .catch((error) => {
        toast.error("Failed To Update");
      });
  };

  return (
    <div className="w-full pb-6 p-4 flex">
      <form className=" w-full" onSubmit={handleSubmit(onSubmit)}>
        <div class="px-2">
          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-1/2 px-4">
              <Select
                onSearch={(value) => handleLocations(value)}
                name="locations"
                placeholder="Search Location"
                label="Location"
                control={control}
                options={locations?.map((oOption, index) => {
                  return {
                    value: index,
                    label: oOption,
                  };
                })}
                allowClear
                // onClear={() => {
                //   setValue("job", undefined);
                // }}
                // onChange={onChangeType}
                // mode="multiple"
                showSearch
                //  options={skillData}
                rules={{
                  required: "This field is required",
                }}
                // className="multiSelect h-12"
              />

              {/* <Input
                name="location"
                label="Location"
                placeholder="eg.koci,kerala,india"
                control={control}
                // className="h-12 "
              /> */}
              {/* <Select
                                label="Current Location"
                                placeholder="Search locations"
                                style={{ width: '100%' }}
                                //fetching={isJobListFetching}
                                onSearch={(value) => handleSearch(value)}
                                options={selectedLocation}
                                // rhf
                                name="location"
                                control={control}
                                showSearch
                                allowClear
                                onClear={() => {
                                    setValue('job', undefined);
                                }}
                                rules={{
                                    required: 'This field is required',
                                }}
                                useDefaultTheme
                            /> */}
            </div>
            <div class="w-1/2 px-4">
              <Input
                name="total_exp"
                label="Total Experience"
                control={control}
                // rules={{
                //   required: "This field is required",
                // }}
                // className="h-12 "
              />
            </div>
          </div>

          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-1/2 px-4">
              <Input
                name="notice_period"
                label="Notice Period"
                control={control}
                rules={{
                  required: "This field is required",
                }}
                // className="h-12 "
              />
              {/* <Select
                                name="notice_period"
                                placeholder="Select"
                                label="Notice Period"
                                control={control}
                                options={noticeTypes}

                                className="multiSelect h-12"
                            /> */}
            </div>
            <div class="w-1/2 px-4">
              <Select
                name="preferred_working_condition"
                placeholder="Select"
                label="Work Preference"
                control={control}
                options={preferredWorkingCondition?.map((oOption) => {
                  return {
                    value: oOption.id,
                    label: oOption.condition,
                  };
                })}
                onChange={(e, onChange) => onChange(e.value)}
                className="multiSelect "
              />
            </div>
          </div>

          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-1/2 px-4 " >
              <CTCField control={control} />
            </div>
            <div class="w-1/2 px-4">
              <DatePicker
                label="DOB"
                name={"dob"}
                noTextInput
                showToday
                rules={{
                  required: "This field is required",
                }}
                control={control}
                placeholder="Select"
                format={"DD-MM-YYYY"}
                // disablePreviousDays
                // className="h-12"
                disableFutureDays={true}
              />
            </div>
          </div>

          <div class="flex -mx-2 md:flex-row flex-col">
            <div class="w-1/2 px-4 flex-wrap">
              <Select
                onSearch={(value) => handleLangages(value)}
                name="languages"
                placeholder="Search Languages"
                label="Languages Known"
                control={control}
                options={languages?.results?.map((oOption) => {
                  return {
                    value: oOption.id,
                    label: oOption.language,
                  };
                })}
                // onChange={onChangeType}
                mode="multiple"
                showSearch
                //  options={skillData}
                rules={{
                  required: "This field is required",
                }}
                // className="multiSelect h-12"
              />
            </div>
            <div class="w-1/2 px-4">
              <Select
                onSearch={(value) => handleNationality(value)}
                name="nationality"
                placeholder="Search Nationality"
                label="Nationality"
                control={control}
                options={natinalityKnown?.results?.map((oOption) => {
                  return {
                    value: oOption.id,
                    label: oOption.nationality,
                  };
                })}
                // onChange={(e, onChange) => onChange(e.value)}
                className="multiSelect"
                showSearch
                //  options={skillData}
                rules={{
                  required: "This field is required",
                }}
                // className="h-12"
              />
            </div>
          </div>
          <div class="flex -mx-2 md:flex-row flex-col">
            <div className="w-1/2 px-4">
              <RadioGroup
                name="disability"
                label="Are you a physically disabled person"
                control={control}
                // rules={{
                //   required: "At least 1 option must be chosen",
                // }}
                options={ANSWER_OPTIONS}
              />
              {selectedType === "true" && (
                <div class="w-full">
                  <div class="flex -mx-2  md:flex-row flex-col">
                    <div className="w-full px-2">
                      <Input
                        name="disability_type"
                        label="Mention the disability "
                        placeholder=""
                        control={control}
                        rules={{
                          required: "This field is required",
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-wrap justify-end mt-6 px-4">
          <Button
            htmlType="submit"
            type="submit"
            className="bg-[#000000] text-white text-base rounded-3xl"
          >
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};
export default BasicDetails;
